import { isBefore } from 'date-fns';

import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const ADVENT_2024_CAMPAIGN_END_DATE = d(2024, 12, 24, 0);

export const advent2024DrawDates = Array.from({ length: 24 }, (_, i) => d(2024, 12, i + 1, 12));

export const getNextAdvent2024DrawDate = () => {
  const now = new Date();
  return advent2024DrawDates.find((date) => isBefore(now, date)) || advent2024DrawDates.at(-1)!;
};
